import Swiper from 'swiper/bundle';
import { BREAK_POINTS } from '@/js/constants';

const REQUIRED_SLIDER_COUNT = 4;

class ShowcaseCarousel {
  constructor (el) {
    this.el = el;
    this.slideEls = null;
    this.controlsEl = null;
    this.slideLength = 0;
    this.swiper = null;

    if (this.el) {
      this.initialize();
    }
  }

  initialize() {
    this.slideEls = this.el.querySelectorAll('.swiper-slide');
    this.controlsEl = this.el.querySelector('.js-carousel-controls');
    this.slideLength = this.slideEls.length;

    if (this.slideLength < REQUIRED_SLIDER_COUNT) {
      this.el.querySelector('.swiper-wrapper').dataset.slider = false;
      this.controlsEl.style.display = 'none';
      return
    }

    this.swiper = new Swiper(this.el, {
      slidesPerView: 1,
      spaceBetween: 21,
      speed: 400,
      autoHeight: true,
      loop: true,
      navigation: {
        prevEl: this.controlsEl.querySelector('.swiper-button-prev'),
        nextEl: this.controlsEl.querySelector('.swiper-button-next'),
      },
      pagination: {
        el: this.el.querySelector('.swiper-pagination')
      },
      breakpoints: {
        // when window width is >= BREAK_POINT
        [BREAK_POINTS.DESKTOP]: {
          slidesPerView: 3,
          spaceBetween: 24,
        }
      }
    })
  }
}

export default class Showcase {
  constructor (selector) {
    this.els = document.querySelectorAll(selector);

    if (this.els) {
      this.initialize();
    }
  }

  initialize() {
    this.els.forEach((el) => {
      const carouselEl = el.querySelector('.js-showcase-carousel');
      this.carousel = new ShowcaseCarousel(carouselEl);
    })
  }
}
